import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import PageHeader from '../PageHeader';
import Icon from '../Icon';
import Card from '../Card';

import './ServiceAreaPageLayout.css';

/**
 * In order not unmount the Coverage Area Component when the user expands the map
 * to full view, some style is applied in this layout making the map full screen and
 * hiding other elements. In this way, we can keep the history of the edition
 */
const ServiceAreaPage = ({
  isFullScreenMapView,
  productsComponent,
  toolbarComponent,
  openingTimesComponent,
  coverageAreaComponent,
  pageHeaderWithoutBackgroundGradient,
  onQuitMapView,
}) => {
  return (
    <Fragment>
      <PageHeader
        classNames={classnames({
          'ServiceAreaPageLayout__fullscreen-map-header': isFullScreenMapView,
        })}
        title={
          <PageTitle isFullScreenMapView={isFullScreenMapView} onQuitMapView={onQuitMapView} />
        }
        withoutBackgroundGradient={pageHeaderWithoutBackgroundGradient}
        toolbar={!isFullScreenMapView && toolbarComponent}
      />
      <div className={classnames({ ServiceAreaPageLayout__content: !isFullScreenMapView })}>
        {!isFullScreenMapView && (
          <div className="ServiceAreaPageLayout__forms">
            <Card.Header>
              <FormattedMessage id="serviceareas.title.products" />
            </Card.Header>
            <Card>{productsComponent}</Card>
            <Card.Header>
              <FormattedMessage id="serviceareas.title.opening.times" />
            </Card.Header>
            <Card>{openingTimesComponent}</Card>
          </div>
        )}

        <div className="ServiceAreaPageLayout__map">
          {!isFullScreenMapView && (
            <Card.Header>
              <FormattedMessage id="serviceareas.title.map" />
            </Card.Header>
          )}

          <Card
            classNames={classnames({
              'ServiceAreaPageLayout__fullscreen-map': isFullScreenMapView,
            })}
          >
            {coverageAreaComponent}
          </Card>
        </div>
      </div>
    </Fragment>
  );
};

const PageTitle = ({ isFullScreenMapView, onQuitMapView }) =>
  isFullScreenMapView ? (
    <React.Fragment>
      <Icon
        onClick={onQuitMapView}
        className="ServiceAreaPageLayout__header-button"
        type="returnArrow"
        iconColor="white"
      />
      <FormattedMessage id="serviceareas.mapview.title" />
    </React.Fragment>
  ) : (
    <FormattedMessage id="serviceareas.title" />
  );

PageTitle.propTypes = {
  isFullScreenMapView: PropTypes.bool.isRequired,
  onQuitMapView: PropTypes.func.isRequired,
};

ServiceAreaPage.propTypes = {
  isFullScreenMapView: PropTypes.bool,
  productsComponent: PropTypes.node,
  toolbarComponent: PropTypes.node,
  openingTimesComponent: PropTypes.node,
  coverageAreaComponent: PropTypes.node,
  pageHeaderWithoutBackgroundGradient: PropTypes.bool,
  onQuitMapView: PropTypes.func,
};

ServiceAreaPage.defaultProps = {
  isFullScreenMapView: false,
  productsComponent: null,
  toolbarComponent: null,
  openingTimesComponent: null,
  coverageAreaComponent: null,
  pageHeaderWithoutBackgroundGradient: false,
  onQuitMapView: Function.prototype,
  shouldShowListOfServiceAreas: false,
};

export default ServiceAreaPage;



// WEBPACK FOOTER //
// ../ui-components/components/ServiceAreaPageLayout/ServiceAreaPageLayout.jsx